import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Container, Box, Typography, Grid } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import IconFactory from 'icons/IconFactory/IconFactory'
import RouteMap from 'assets/RouteMap'
import { usePipedrive } from 'hooks/usePipedrive'
import PipedriveFormModal from 'modals/PipedriveFormModal/PipedriveFormModal'
import { useStyles } from './IntegrationIndexPage_style'
import { DASHBOARD_FONT_EXEMPT_CLASS } from 'assets/GlobalTheme'
import IntegrationItem from './components/IntegrationItem'
import CTANewIntegration from './components/CTANewIntegration'

const IntegrationIndexPage = (props) => {
    const { integrations = [] } = props
    const classes = useStyles()
    const { getUrlIntegrationContactForm } = usePipedrive()
    const [openFormModal, setOpenFormModal] = useState(false)

    return (
        <Container maxWidth='lg' className={classes.container}>
            <PipedriveFormModal
                open={openFormModal}
                onClose={() => setOpenFormModal(false)}
                url={getUrlIntegrationContactForm()}
            />

            <Box mb={4}>
                <Typography variant='h1' className={`${classes.title} ${DASHBOARD_FONT_EXEMPT_CLASS}`}>
                    <FormattedMessage id='employer_dashboard.sidebar.section_titles.integrations' />
                </Typography>
                <Typography variant='body1' className={classes.subtitle}>
                    <FormattedMessage id='integrations_catalogue.subtitle' />
                </Typography>
            </Box>

            <Grid container spacing={3} alignItems='flex-start'>
                <Grid item xs={12} md={9}>
                    <Grid container spacing={3}>
                        {integrations.map((integration) => (
                            <Grid item xs={12} sm={6} md={4} key={integration.id}>
                                <IntegrationItem
                                    integration={integration}
                                    onContactClick={() => setOpenFormModal(true)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Grid item xs={12} md={3} className={classes.sidebar}>
                    <CTANewIntegration onContactClick={() => setOpenFormModal(true)} />
                </Grid>
            </Grid>

            <Box className={classes.apiDocsRow}>
                <Link href={RouteMap.ApiDocs()} target='_blank' rel='noopener noreferrer' className={classes.apiDocsLink}>
                    <IconFactory icon='expand' />
                    <FormattedMessage id='integrations_catalogue.api_docs' />
                </Link>
            </Box>
        </Container>
    )
}

export default IntegrationIndexPage
